import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import RenderHtml from "../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml";

const PreviewProcedureRevision = ({ version_content }) => {
  return (
    <>
      <form className="procedure-form" style={{ marginTop: "-30px" }}>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              Document Number
              <span
                style={{ marginLeft: "-1px", fontSize: "15px" }}
                className="required"
              >
                *
              </span>{" "}
              (Read Only)
            </label>
            <div className="input-with-icon">
              <input
                type="text"
                style={{
                  borderRadius: "5px 0px 0px 5px",
                  borderRight: "none",
                  backgroundColor: "white",
                  color: "#999999",
                }}
                value={version_content.procedure_number}
                
                readOnly
                // disabled={true}
              />
              <button
                type="button"
                style={{
                  borderRight: "1px solid rgb(215, 215, 215)",
                  borderTop: "1px solid rgb(215, 215, 215)",
                  borderBottom: "1px solid rgb(215, 215, 215)",
                  borderLeft: "none",
                  borderRadius: "0px 5px 5px 0px",
                  backgroundColor: "#f4f5f7",
                }}
                className=""
              >
                <FontAwesomeIcon
                  style={{
                    color: "#86b7fe", // Light gray color for disabled look
                    paddingTop: "7.6px",
                    paddingBottom: "7.6px",
                    paddingLeft: "7px",
                    paddingRight: "7px",
                    pointerEvents: "none", // Disable pointer events
                  }}
                  icon={faPencil}
                />
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>
              Document Type
              <span
                style={{ marginLeft: "-1px", fontSize: "15px" }}
                className="required"
              >
                *
              </span>{" "}
              (Read Only)
            </label>
            <input
              type="text"
              style={{ color: "#999999" }}
              value={version_content.procedure_type}
              readOnly
            />
          </div>
          <div className="form-group">
            <label>References (Separate Each Reference using Space Key)</label>
            <input
              type="text"
              value={version_content.reference}
              readOnly
            />
          </div>
        </div>

        <div className="form-row" style={{ marginTop: "-30px" }}>
          <div className="form-group">
            <label>
              Document Description
              {" "}
              (Read Only)
            </label>
            
            <RenderHtml
              content={version_content.procedure_description}
              descriptionBox={true}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>
              Revision Details
              <span
                style={{ marginLeft: "-1px", fontSize: "15px" }}
                className="required"
              >
                *
              </span>
            </label>
            <textarea
            
            value={version_content.revision_details}
            style={{
              minHeight: "100px",
              whiteSpace: 'pre-wrap',
              width: "100%",
              resize: "none"
            }}
            readOnly
          ></textarea>
          </div>
        </div>
      </form>
      <div style={{ paddingBottom: "10px" }}></div>
    </>
  );
};

export default PreviewProcedureRevision;
